import createStore from "redux-zero";

const initialState = { lastSimulation: null };
const store = createStore(initialState);

export default store;